import { legacy_createStore,combineReducers } from "@reduxjs/toolkit";
import ProductsReducer from "./Slice";

const loadfromlocalstorage = () => {
      try{
      const localStorageitems = localStorage.getItem("c_t");
      if(localStorageitems === null){
        return undefined;
      }

      return JSON.parse(localStorageitems);
      }catch(err){
        return undefined;
      }
}

const singlereducer = combineReducers({
   
        products: ProductsReducer
    
})

const preloadfromlocalstorage = {

  products: {
    items: loadfromlocalstorage() || []
  }

}

const store = legacy_createStore(singlereducer,preloadfromlocalstorage);

store.subscribe(()=>{
  try{
    const state = store.getState();

    const itemstosave = JSON.stringify(state.products.items)
    localStorage.setItem('c_t',itemstosave)
  }catch(err){
    return undefined;
  }
})

if (process.env.NODE_ENV !== 'production') {
  window.store = store; 
}


export default store;